module.exports = __webpack_public_path__ + "static/media/logo-oss-portal.2a194b2e.png";